var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-btn",
        {
          staticClass: "mr-2",
          attrs: {
            outlined: _vm.$route.name !== "suppliers.create",
            color: "primary",
            small: true
          },
          on: {
            click: function($event) {
              return _vm.$router.push({ name: "suppliers.create" })
            }
          }
        },
        [_c("span", { staticClass: "caption" }, [_vm._v("New Supplier")])]
      ),
      _c(
        "v-btn",
        {
          staticClass: "mr-2",
          attrs: {
            outlined: _vm.$route.name !== "suppliers.table",
            color: "primary",
            small: true
          },
          on: {
            click: function($event) {
              return _vm.$router.push({ name: "suppliers.table" })
            }
          }
        },
        [_c("span", { staticClass: "caption" }, [_vm._v("Suppliers")])]
      ),
      _c(
        "v-btn",
        {
          staticClass: "mr-2",
          attrs: {
            outlined: _vm.$route.name !== "suppliers.categories",
            color: "primary",
            small: true
          },
          on: {
            click: function($event) {
              return _vm.$router.push({ name: "suppliers.categories" })
            }
          }
        },
        [_c("span", { staticClass: "caption" }, [_vm._v("Category")])]
      ),
      _c(
        "v-card",
        { staticClass: "mt-2", attrs: { "min-height": "80vh" } },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }